// Re-extraction status (DPS-4715): the hub's summary of the healing agent's
// newest `reextraction_planned` plan for a merged fix. Shape from the backend:
// { status, seeds, runs, window_start, window_end, page_type, reason, planned_at, mode }.
// status is 'planned_log_only', 'not_possible', or any later agent outcome
// (triggered / completed, DPS-4712/4713) passed through raw.

export const PLANNED_LOG_ONLY = 'planned_log_only';
export const NOT_POSSIBLE = 'not_possible';

const REASONS = {
  no_seeds: 'no seeds found',
  query_failed: 'the seed count query failed',
  unmapped_page_type: 'this page type has no re-extraction mapping',
};

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function parseDay(value) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(typeof value === 'string' ? value.trim() : '');
  if (!m) return null;
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  if (mo < 1 || mo > 12 || d < 1 || d > 31) return null;
  return { y, mo, d };
}

/** '1–30 Oct', '7 Oct – 5 Nov', '5 Dec 2025 – 3 Jan 2026' or '30 Oct'; null when a date is missing. */
export function formatWindow(start, end) {
  const a = parseDay(start);
  const b = parseDay(end);
  if (!a || !b) return null;
  const mon = (x) => MONTHS[x.mo - 1];
  if (a.y !== b.y) return `${a.d} ${mon(a)} ${a.y} – ${b.d} ${mon(b)} ${b.y}`;
  if (a.mo !== b.mo) return `${a.d} ${mon(a)} – ${b.d} ${mon(b)}`;
  if (a.d === b.d) return `${a.d} ${mon(a)}`;
  return `${a.d}–${b.d} ${mon(a)}`;
}

const isCount = (n) => Number.isInteger(n) && n >= 0;
const plural = (n, one, many) => `${n.toLocaleString('en-US')} ${n === 1 ? one : many}`;

function planParts(plan) {
  const parts = [];
  if (isCount(plan.seeds)) parts.push(plural(plan.seeds, 'seed', 'seeds'));
  if (isCount(plan.runs)) parts.push(plural(plan.runs, 'run', 'runs'));
  const window = formatWindow(plan.window_start, plan.window_end);
  if (window) parts.push(window);
  return parts;
}

function reasonWords(reason) {
  if (!reason) return null;
  return REASONS[reason] || String(reason).replace(/_/g, ' ');
}

/** One line for a plan, or null when there is no plan. */
export function reextractionText(plan) {
  if (!plan || !plan.status) return null;
  if (plan.status === PLANNED_LOG_ONLY) {
    return `${['Planned', ...planParts(plan)].join(' · ')} (log-only, not run)`;
  }
  if (plan.status === NOT_POSSIBLE) {
    const words = reasonWords(plan.reason);
    return words ? `Not possible: ${words}` : 'Not possible';
  }
  return [String(plan.status), ...planParts(plan)].join(' · ');
}

/** 'planned' | 'not_possible' | 'other' — picks the chip colour. */
export function reextractionTone(status) {
  if (status === PLANNED_LOG_ONLY) return 'planned';
  if (status === NOT_POSSIBLE) return 'not_possible';
  return 'other';
}
